import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import it from './locales/it.json'

// Italian only for now (subproject 4 adds de/fr/en). Synchronous init so the
// first render and the tests already have the texts.
i18n.use(initReactI18next).init({
  resources: { it: { translation: it } },
  lng: 'it',
  fallbackLng: 'it',
  interpolation: { escapeValue: false },
  initImmediate: false,
})

export default i18n
